module.exports = __webpack_public_path__ + "static/p6-95c22db4299d89e85266488088f90a05.png";